import { createContext, useCallback, useContext, useState } from "react";

const AiAssistantContext = createContext(null);

export function AiAssistantProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const [assistantContext, setAssistantContext] = useState({ type: "general" });

  const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  const setContext = useCallback((data) => setAssistantContext(data || { type: "general" }), []);

  return (
    <AiAssistantContext.Provider value={{ isOpen, toggle, open, close, context: assistantContext, setContext }}>
      {children}
    </AiAssistantContext.Provider>
  );
}

export function useAiAssistant() {
  const ctx = useContext(AiAssistantContext);
  if (!ctx) throw new Error("useAiAssistant must be used within AiAssistantProvider");
  return ctx;
}

export default AiAssistantContext;
